exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px){.product-listing[data-v-d9f8513e]{padding-left:8px;padding-right:8px}}@media (max-width: 767px){.product-listing-box-row[data-v-d9f8513e]{padding-left:0;padding-right:0 !important;padding-bottom:2px !important}}.product-listing-box[data-v-d9f8513e]{padding-bottom:30px}@media (max-width: 767px){.product-listing-box[data-v-d9f8513e]{padding-left:7px;padding-right:7px;padding-bottom:15px}}\n", ""]);

// exports
